import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const logoUrl = '/defera-logo-web.png';

  return (
    <footer className="w-full bg-black border-t border-white/5 py-10 mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 gap-8 mb-8">
          {/* Left: Logo and Links (Desktop: stacked, Mobile: far left) */}
          <div className="flex flex-col items-start gap-4">
            <img 
              src={logoUrl} 
              alt="Defera Logo" 
              className="h-14"
            />
            {/* Links below logo on desktop - Two Columns */}
            <div className="hidden md:grid grid-cols-2 gap-x-8 gap-y-2 text-xs leading-none">
              <Link to="/terms" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Terms & Conditions
              </Link>
              <Link to="/customers" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Customer Stories
              </Link>
              <Link to="/privacy" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Privacy Policy
              </Link>
              <Link to="/privacy-choices" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Do Not Sell or Share My Personal Information
              </Link>
              <Link to="/press" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Press
              </Link>
              <Link to="/reserve/terms" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Reserve Terms
              </Link>
              <Link to="/guides" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Guides
              </Link>
              <Link to="/support" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Chat with Concierge
              </Link>
              <Link to="/help" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Help Center
              </Link>
              <Link to="/security" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Security
              </Link>
              <Link to="/newsroom" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Newsroom
              </Link>
              <Link to="/rewards" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Rewards
              </Link>
              <Link to="/charter" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Our Charter
              </Link>
              <Link to="/contact" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Contact Us
              </Link>
              <Link to="/about" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                About Us
              </Link>
              <Link to="/careers" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Careers
              </Link>
            </div>
          </div>

          {/* Mobile: Left and Center Links - Two Columns */}
          <div className="md:hidden">
            <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-xs leading-none">
              <Link to="/terms" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Terms & Conditions
              </Link>
              <Link to="/customers" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Customer Stories
              </Link>
              <Link to="/privacy" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Privacy Policy
              </Link>
              <Link to="/privacy-choices" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Do Not Sell or Share My Personal Information
              </Link>
              <Link to="/press" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Press
              </Link>
              <Link to="/reserve/terms" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Reserve Terms
              </Link>
              <Link to="/guides" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Guides
              </Link>
              <Link to="/support" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Chat with Concierge
              </Link>
              <Link to="/help" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Help Center
              </Link>
              <Link to="/security" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Security
              </Link>
              <Link to="/newsroom" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Newsroom
              </Link>
              <Link to="/rewards" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Rewards
              </Link>
              <Link to="/charter" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Our Charter
              </Link>
              <Link to="/contact" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Contact Us
              </Link>
              <Link to="/about" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                About Us
              </Link>
              <Link to="/careers" className="text-white/60 hover:text-white transition-colors font-normal text-left">
                Careers
              </Link>
            </div>
          </div>

        </div>

        {/* Divider */}
        <div className="border-t border-white/5 pt-6">
          {/* Copyright and Disclaimer (Desktop: centered, Mobile: left-aligned) */}
          <div className="space-y-2.5">
            <p className="text-white/40 text-xs font-normal text-left md:text-center">
              Copyright © {new Date().getFullYear()} Defera LLC. All Rights Reserved
            </p>
            <p className="text-white/15 text-[10px] font-normal text-left md:text-center leading-tight md:max-w-4xl md:mx-auto">
              Defera LLC is partnered with a fully accredited organization in multiple countries that maintains direct and indirect relationships with various airline carriers and hotel chains. Some carriers and hotels may not be available for booking due to the absence of an established partnership. All cancellation and change policies are governed by the respective airline and not by Defera LLC.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
